<template>
  <div @click="clickEvent">
    <div 
      class="ProgressButton mcp"
      :class="{ deliveryDateNotAvailable: !isDeliveryDateAvailable }"
      @click.prevent="percentProgress >= 100  ? (next ? $emit('next-step') : (isDeliveryDateAvailable ? $emit('checkout') : '')) : scrollToError()"
    >
      <button
          :style="{ width: percentProgress + '%' }"
          class="Button Button-danger"
          :class="{ display: percentProgress > 0, 'label-active': percentProgress >= 100 }"
          disabled
      ></button>

      <span v-if="next">Suivant</span>
      <span v-else>Valider <template v-if="order === true">ma commande et payer</template></span>
    
      <button
        class="Button not-filled"
        :class="{ disabled: isNotFull, 'Button-active': percentProgress >= 100 }"
        :disabled="percentProgress < 100 || hiddenButton"
        type="button">
      </button>

    </div>
    
    <p v-if="!next && !isDeliveryDateAvailable && !fromWizardForm" class="slot-not-available">Le créneau horaire du rendez-vous n'est plus valable.</p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import "@/components/ProgressButton/ProgressButton.scss";
import EventBus from "@/event-bus";

export default {
  name: "ProgressButton",
  data () {
    return {
      isNotFull: true,
    };
  },
  props: {
    hiddenButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    order: {
      type: Boolean,
      default: true,
    },
    lastStep: {
      type: Boolean,
      default: false,
    },
    next: {
      type: Boolean,
      default: false
    },
    fromWizardForm: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters({ getCheckoutPercentFill: "getCheckoutPercentFill" }),
    ...mapGetters({ getWizardPercentFill: "getWizardPercentFill" }),
    ...mapGetters({ getWizardPercentFillLast: "getWizardPercentFillLast" }),
    ...mapGetters({ isDeliveryDateAvailable: "getDeliveryDateAvailability"}),
    
    percentProgress () {
      if (this.order === true) {
        return this.getCheckoutPercentFill;
      }
      if (this.lastStep === true) {
        return this.getWizardPercentFillLast;
      }
      return this.getWizardPercentFill;
    },
  },
  mounted() {
    if (this.percentProgress < 59) {
      this.isNotFull = true;
    } else {
      this.isNotFull = false;
    }
  },
  watch: {
    percentProgress (newValue) {
      if (this.percentProgress < 59) {
        this.isNotFull = true;
      } else {
        this.isNotFull = false;
      }
    },
  },

  methods: {
    scrollToError() {
      EventBus.$emit("scroll-to-error")
    },

    clickEvent() {
      this.$emit("progressButtonClicked")
    }
  },
};
</script>